import {observer} from 'mobx-react-lite'
import appStore from '../../../storage/AppStore'
import Btn from '../../../ui/Btn'
import clubStore from '../../../storage/ClubStore'
import systemStore from '../../../storage/SystemStore'

const AttendanceItem = ({ period }) => {
  return (
    <div className="col-12">
      
      {/* Month header */}
      <div className="flex align-items-center mb-2">
        <span className="text-lg font-semibold">
          {appStore.tr[period.month]} {period.year}
        </span>
        <span className="ml-2 text-600">
          ({period.attended}/{period.total})
        </span>
      </div>
      
      {/* Classes list */}
      <div className="flex flex-column gap-2">
        {period.classes.map((cls) => (
          <div
            key={cls.id}
            className="flex justify-content-between align-items-center billing-item"
          >
            
            {/* Left */}
            <div className="flex flex-column">
              <span className="font-medium">
                {cls.team.name}
              </span>
              <span className="text-sm text-500">
                {cls.date}
              </span>
            </div>
            {cls.has_album && (
              <div className={"flex"}>
                <Btn icon={'pi pi-images'}
                     outlined
                     onClick={() => {
                       clubStore.parent.sendClassPhotos(cls.id).then(() => {
                         systemStore.setSuccess(appStore.tr.media_sent_to_telegram)
                       })
                     }}
                />
              </div>
              )}
            
            {/* Right status */}
            <div className="flex align-items-center">
              <i className="pi pi-check-circle text-green-500 text-xl"/>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default observer(AttendanceItem)